module.exports = __webpack_public_path__ + "img/best_advice_logo.242144a0.png";